import * as THREE from "../src/insole-web-common/vendor/three/build/three.module.js";
import { rad2deg } from "./insole-web-common/src/engine/parameters.js";
import { GetLocalizedString } from "./localization.js";
export const truncate = (num, places) => Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
export const formatNumber = (value, format, unit) => typeof value === "number" ? `${format} ${+value.toFixed(2)}${unit || ""}` : "-";
export const formatPresence = (value, format) => {
    if (value === "presets/values/none" || !value) {
        return GetLocalizedString("presets/values/none");
    }
    return format;
};
export const setFileErrorNotification = (isError, type, secondaryFlag = false) => {
    const errorNotification = document.querySelector("#error-notification");
    const errorNotificationText = errorNotification.querySelector("div");
    if (isError) {
        errorNotification.classList.remove("hidden");
        switch (type) {
            case "presetFile":
            case "metadataFile":
                errorNotificationText.textContent = secondaryFlag
                    ? "Cannot parse JSON file."
                    : "Invalid file type, expecting a JSON file.";
                break;
            case "file":
                errorNotificationText.textContent =
                    "Failed to " + (secondaryFlag ? "export insole" : "import foot scan");
                break;
            default:
                unreachable(type);
        }
    }
    else {
        errorNotification.classList.add("hidden");
    }
};
export function IsNullish(value) {
    return value === null || value === undefined;
}
export function IsNotNullish(value) {
    return value !== null && value !== undefined;
}
export function EnsureNumberOrNullish(value) {
    if (typeof value === "number") {
        return value;
    }
    if (IsNullish(value)) {
        return value;
    }
    return null;
}
export function EnsureBooleanOrNullish(value) {
    if (typeof value === "boolean") {
        return value;
    }
    if (IsNullish(value)) {
        return value;
    }
    return null;
}
export function EnsureStringOrNullish(value) {
    if (typeof value === "string") {
        return value;
    }
    if (IsNullish(value)) {
        return value;
    }
    return null;
}
export function GetNestedProperty(obj, path) {
    const segments = path.split(".");
    let current = obj;
    for (let i = 0; i < segments.length; ++i) {
        if (typeof current !== "object") {
            return undefined;
        }
        if (current === null) {
            return undefined;
        }
        current = current[segments[i]];
    }
    return current;
}
export function Float3ToVector3(v) {
    return new THREE.Vector3(v.x, v.y, v.z);
}
export function Vector3ToFloat3(v) {
    return { x: v.x, y: v.y, z: v.z };
}
export function Float4ToVector4(v) {
    return new THREE.Vector4(v.x, v.y, v.z, v.w);
}
export function Vector4ToFloat4(v) {
    return { x: v.x, y: v.y, z: v.z, w: v.w };
}
export function Float4ToQuaternion(v) {
    return new THREE.Quaternion(v.x, v.y, v.z, v.w);
}
export function QuaternionToFloat4(v) {
    return { x: v.x, y: v.y, z: v.z, w: v.w };
}
export function printVec3(title, p, decimals) {
    if (decimals !== undefined) {
        console.log(title, ": ", p.x.toFixed(decimals), " ", p.y.toFixed(decimals), " ", p.z.toFixed(decimals));
    }
    else {
        console.log(title, ": ", p.x, " ", p.y, " ", p.z);
    }
}
export function printEuler(title, e, decimals) {
    const x = e.x * rad2deg;
    const y = e.y * rad2deg;
    const z = e.z * rad2deg;
    if (decimals !== undefined) {
        console.log(title, ": ", e.x.toFixed(decimals), " ", e.y.toFixed(decimals), " ", e.z.toFixed(decimals));
    }
    else {
        console.log(title, ": ", e.x, " ", e.y, " ", e.z);
    }
}
export function printQuaternionAsEuler(title, q, decimals) {
    const e = new THREE.Euler();
    e.setFromQuaternion(q);
    printEuler(title, e, decimals);
}
export function updateObjectTransform(obj) {
    // It's like updateMatrix but in the other way, setting position, quaternion, scale and rotation from the matrix
    obj.matrix.decompose(obj.position, obj.quaternion, obj.scale);
    obj.rotation.setFromQuaternion(obj.quaternion);
}
//# sourceMappingURL=util.js.map